const CURRENT_SESSION_KEY = 'neo-chatbot-current-session'
const THEME_KEY = 'neo-chatbot-theme'

export function loadCurrentSessionId(): string | null {
  try {
    return localStorage.getItem(CURRENT_SESSION_KEY)
  } catch {
    return null
  }
}

export function saveCurrentSessionId(id: string | null): void {
  try {
    if (id) {
      localStorage.setItem(CURRENT_SESSION_KEY, id)
    } else {
      localStorage.removeItem(CURRENT_SESSION_KEY)
    }
  } catch {
    // ignore
  }
}

export function clearCurrentSessionId(): void {
  try {
    localStorage.removeItem(CURRENT_SESSION_KEY)
  } catch {
    // ignore
  }
}

/** Load saved theme preference. Returns null if none saved (use system default). */
export function loadTheme(): 'dark' | 'light' | null {
  try {
    const val = localStorage.getItem(THEME_KEY)
    if (val === 'dark' || val === 'light') return val
    return null
  } catch {
    return null
  }
}

export function saveTheme(theme: 'dark' | 'light'): void {
  try {
    localStorage.setItem(THEME_KEY, theme)
  } catch {
    // ignore
  }
}
